import { render, staticRenderFns } from "./playerprofile.vue?vue&type=template&id=bc5d1bee&scoped=true"
import script from "./playerprofile.vue?vue&type=script&lang=js"
export * from "./playerprofile.vue?vue&type=script&lang=js"
import style0 from "./playerprofile.vue?vue&type=style&index=0&id=bc5d1bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5d1bee",
  null
  
)

export default component.exports